import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var GrabIcon = function GrabIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "GrabIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.958 5.353q-.253.049-.492.174l-.301.158A2.18 2.18 0 0 0 1 7.62v1.138a2.45 2.45 0 0 0 1.072 2.028l1.608 1.092.23 1.156A2.44 2.44 0 0 0 6.3 15h4.752a2.44 2.44 0 0 0 2.436-2.447v-.854l.89-2.341q.076-.202.117-.414l.466-2.452c.047-.248.052-.503.012-.753l-.207-1.316c-.183-1.168-1.236-1.712-2.176-1.548-.583-.927-1.795-1.21-2.72-.728a2.144 2.144 0 0 0-2.647-.262C6.044.342 3.373.876 3.073 3.02l-.039.277zM2.42 7.62c0-.28.156-.539.404-.669l.3-.159a.38.38 0 0 1 .5.134c.201.318.69.185.704-.191l.123-3.311.029-.204c.13-.932 1.406-1.087 1.753-.213l.15.374a.732.732 0 0 0 1.337.056l.037-.074a.699.699 0 0 1 1.29.092l.026.08a.66.66 0 0 0 1.194.132.66.66 0 0 1 1.202.16l.208.73c.048.17.173.273.314.307.115.028.242.01.344-.055l.436-.32a.508.508 0 0 1 .808.415l-.01 1.059-.005.263-.466 2.451a1 1 0 0 1-.049.173l-.916 2.41q-.066.177-.067.365v.928c0 .564-.455 1.02-1.015 1.02H6.3c-.484 0-.9-.343-.996-.82l-.263-1.319a1.02 1.02 0 0 0-.426-.645L2.868 9.602a1.02 1.02 0 0 1-.447-.845z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.99 7.25c.393 0 .711.32.711.713v3.57a.71.71 0 0 1-.71.713.71.71 0 0 1-.711-.713v-3.57c0-.394.318-.714.71-.714M10.036 7.25c.393 0 .711.32.711.713v3.57a.71.71 0 0 1-.71.713.71.71 0 0 1-.711-.713v-3.57c0-.394.318-.714.71-.714",
      clipRule: "evenodd"
    })]
  }));
};

export { GrabIcon };
